import React from 'react'

import Grid from '@mui/material/Grid'
import CompanyName from '../CompanyName'
import { Product } from '@/src/types/api-types'

type Props = {
  product: Product
}

const ProductCompany: React.FC<Props> = ({ product }) => {
  return (
    <Grid container className="rounded p-2" alignItems={'center'}>
      <Grid item xs>
        <div>
          <span>{t({ id: 'web_vendu_et_expedie_par' })}</span> : {''}
          <CompanyName
            object={{
              id: product.company_id,
              name: product.company_name,
              company_seo_name: product.company_seo_name,
            }}
          />
        </div>
      </Grid>
      <Grid>
        {/*<AverageRating*/}
        {/*  rating={companyReview.averageRating}*/}
        {/*  numberOfComments={companyReview.reviews.length}*/}
        {
          /*/>*/
          //@todo refactor
        }
      </Grid>
    </Grid>
  )
}

export default ProductCompany
